<template lang="pug">
  #question
    BCollapse(
      aria-id="expandQuestion"
      :open.sync="expandQuestion"
    )
      .question-header(
        slot='trigger',
        role='button',
        aria-controls='expandQuestion'
        :class="{ 'question-expanded': expandQuestion}"
      )
        div
          span {{ data.question }}
          .is-size-7.has-text-grey.question-description(v-html="data.description")
        a.card-header-icon
          BIcon(:icon="expandQuestion ? 'chevron-up mdi-42px' : 'chevron-down mdi-42px'")
      .question-content
        QuestionPreviewAnswerAdminSuper(:type="data.type" :answers="data.fields" :rangeStart="data.fields.range_start" :rangeEnd="data.fields.range_end")
        .mt-3.is-flex.is-flex-wrap-wrap
          WtButton(
            color="red"
            size="small"
            bold
            @click.native="deleteQuestion"
            :loading="processing"
            :disable="processing"
            class="mr-6 mb-3"
          ) Delete {{data.draft ? 'Draft' : null}}
          .is-flex
            WtButton(
              color="primary"
              size="small"
              bold
              @click.native="editQuestion"
              :disable="processing"
              class="mr-3"
            ) {{data.draft ? 'Update Draft' : 'Edit'}}
            WtButton(
              v-if="data.draft"
              color="primary"
              size="small"
              bold
              @click.native="publishDraft"
              :disable="processing"
              class="mr-3"
            ) Create Question
            RouterLink.p-3.is-size-7.has-text-underlined(
              v-if="data.isWellnessChallenge || _.get(data, 'challengeId', false)"
              :to="{ name: 'Challenge', params: { challengeId: data.challengeId } }"
            ) Visit Challenge

      BModal(:active.sync="editQuestionOpen")
        .modal-card(style='width: auto')
          header.modal-card-head
            p.modal-card-title Edit {{data.draft ? 'Draft' : 'Question'}}
          section.modal-card-body.pb-5
            QuestionBuilderAdminSuper(@cancel="editQuestionOpen = false" :data="data")
</template>

<script>
import QuestionBuilderAdminSuper from "./QuestionBuilderAdminSuper";
import QuestionPreviewAnswerAdminSuper from "./QuestionPreviewAnswerAdminSuper";
import WtButton from "@@/WtButton/WtButton";
import { mapActions } from "vuex";
export default {
  name: "QuestionView",
  components: {
    QuestionPreviewAnswerAdminSuper,
    QuestionBuilderAdminSuper,
    WtButton
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expandQuestion: false,
      editQuestionOpen: false,
      processing: false
    };
  },
  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("program", [
      "deleteProgramQuestion",
      "updateProgramQuestion"
    ]),
    deleteQuestion() {
      this.processing = true;
      this.$buefy.dialog.confirm({
        title: `Delete This ${this.data.draft ? "Draft" : "Question"}`,
        confirmText: `Delete This ${this.data.draft ? "Draft" : "Question"}`,
        type: "is-danger",
        hasIcon: true,
        message: `Are you sure you want delete this ${
          this.data.draft ? "draft" : "question"
        }?`,
        onConfirm: async () => {
          await this.deleteProgramQuestion({ questionId: this.data.id });
          this.processing = false;
        },
        onCancel: () => {
          this.processing = false;
        }
      });
    },
    editQuestion() {
      this.editQuestionOpen = true;
    },
    publishDraft() {
      this.processing = true;
      this.updateProgramQuestion({
        programId: this.$auth.user().programId,
        questionId: this.data.id,
        draft: false
      }).then(() => {
        this.processing = false;
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#question
  margin-left: 16px
  .question-header
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
    span
      font-size: $size-normal
    &:hover
      span
        color: $primary
  .question-content
    padding: 0 8px 8px 8px
  .question-expanded
    span
      color: $primary
.question-description /deep/ a
  color: $primary
</style>
